import { Bento } from "../components/Bento";
import { t } from "@/i18n-js/instance";
import TotalWorkflowsRun from "./assets/total-workflows-run.png";

import { SanitizeHTMLString } from "@/react/components/shared/uikit/SanitizeContent";
import { abbreviateNumber } from "@/react/helpers/number";

const i18nRoot = "eoy_recap_2025.sections.efficiency";

import type { AutomationEfficiencyMetrics } from "../../types";
import { MostUsedAutomation } from "./MostUsedAutomation";

interface EfficiencyProps {
  data?: AutomationEfficiencyMetrics;
}

export const Efficiency = ({ data }: EfficiencyProps) => {
  if (!data) return null;

  return (
    <Bento
      id="automation-and-efficiency"
      accentColor="#06892B"
      title={t([i18nRoot, "title"])}
    >
      <Bento.Item id="total-workflows-run" baseColSpan={1} baseRowSpan={3}>
        <div className="flex flex-col h-full p-8">
          <p className="text-4xl md:text-6xl font-bold mb-2">
            {abbreviateNumber(data.total_workflows_run)}
          </p>
          <p className="text-base font-medium leading-none tracking-[-0.25px] text-white mb-4">
            {t([i18nRoot, "bento_items.total_workflows_run"])}
          </p>
          <div className="flex-1 min-h-0 mt-4">
            <img
              src={TotalWorkflowsRun}
              alt={t([i18nRoot, "bento_items.total_events_hosted"])}
              className="size-full"
              loading="lazy"
            />
          </div>
        </div>
      </Bento.Item>
      <Bento.Item id="most-used-automation" baseColSpan={1} baseRowSpan={3}>
        <div className="flex flex-col items-center justify-start gap-20 h-full p-8">
          <p className="text-4xl font-bold mb-2 leading-8">
            <SanitizeHTMLString
              content={t([i18nRoot, "bento_items.most_used_automation"])}
            />
          </p>
          <MostUsedAutomation title={data.most_used_autonation} />
        </div>
      </Bento.Item>
      <Bento.Item id="minutes-saved" baseColSpan={1} baseRowSpan={2}>
        <div className="flex flex-col justify-start items-center size-full overflow-hidden p-8">
          <p className="text-center text-[32px] font-bold leading-[100%] tracking-[-1.5px]">
            <SanitizeHTMLString
              content={t([
                i18nRoot,
                "bento_items.tasks_saved_time_saved_estimated",
              ])}
            />
          </p>
          <div className="flex flex-col items-center justify-center mt-20">
            <p className="text-[120px] font-bold leading-[100%] tracking-[-8.135px] uppercase text-[#0FBD41]">
              {abbreviateNumber(data.minutes_saved)}
            </p>
            <p className="text-center text-[32px] font-bold leading-[100%] tracking-[-1.5px] text-[#0FBD41]">
              <SanitizeHTMLString
                content={t([i18nRoot, "bento_items.minutes_saved_per_month"])}
              />
            </p>
          </div>
        </div>
      </Bento.Item>
    </Bento>
  );
};
